
export class NamedColor {
    readonly name: string;
    readonly color: string;

    constructor(name: string, color: string) {
        this.name = name;
        this.color = color;
    }
}